<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">Ento ELISA Results Data Upload</h2>
      <p class="tw-italic tw-text-gray-700">
        Upload Elisa results data for processing.
      </p>
    </b-container>

    <hr />

    <b-container>
      <b-row>
        <b-col md="6" offset-md="3" class="mt-3">
          <b-form-file
            id="file"
            v-model="selectedFile"
            :state="Boolean(selectedFile)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            size="lg"
          ></b-form-file>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" offset-md="3" class="mt-3">
          <b-button
            @click="onUpload(1)"
            variant="success"
            size="lg"
            block
          >
            Upload
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" offset-md="3" class="mt-3">
          <b-button
            :to="{ name: 'ento-date-range-elisa-result' }"
            variant="warning"
            size="lg"
            block
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <hr>
    <div v-if="fileData.message" class="text-center">
        <h3>{{fileData.message}}</h3>
    </div>

    <div v-if="fileData.missing_columns.length">
        <strong>Missing Columns: </strong>
        {{ fileData.missing_columns.join(", ") }}
    </div>

    <div v-if="fileData.dirty_data.length">
        <h3>Data Errors</h3>
        <b-table striped :items="fileData.dirty_data"></b-table>
    </div>

    <div v-if="fileData.clean_data.length">
        <h3>Clean Data</h3>
        <b-table striped :items="fileData.clean_data"></b-table>
    </div>

    <div class="text-center" v-if="fileData.clean_data.length && !fileData.dirty_data.length && !fileData.missing_columns.length">
        <b-button
            @click="onUpload(0)"
            variant="success"
            size="lg"
            block
          >
            Submit
          </b-button>
    </div>

    <!-- <input type="file" @change="onFileSelected"> -->
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      selectedFile: null,
      fileData: {
          message: '',
          dirty_data: [],
          clean_data: [],
          missing_columns: []
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    onFileSelected: function (event) {
      this.selectedFile = event.target.files[0];
    },
    onUpload: function (preview) {
      const that = this;
      if (!this.selectedFile) {
        return that.$bvModal.msgBoxOk("Please select a file!", {
          title: "File Error",
          okVariant: "danger",
          centered: true,
        });
      }

      that.message = '';

      const fd = new FormData();
      fd.append("file", this.selectedFile, this.selectedFile.name);
      fd.append("preview", preview);
      HTTP.post("/kenya/ento-data/upload-elisa", fd)
        .then((response) => {
            if('done' in response.data) {
                that.fileData = response.data;
                
                that.selectedFile = null;
                this.$notify({
                    text: "File uploaded and saved!",
                    duration: 10000,
                    type: "success",
                });
            } else {
                that.fileData = response.data;
            }
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
  },
};
</script>

<style></style>
